import { ChangeDetectionStrategy, Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';

@Component({
  selector: 'app-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoIconComponent {
  @Input()
  tooltipText: string | TemplateRef<any>;

  @Input()
  tooltipPosition: PlacementArray = 'right';

  @Input()
  customTooltipClass = '';

  @Input()
  ensureKeepOnHover = false;

  @Input()
  shouldTriggerTooltipByClick = false;

  @Input()
  colorType: 'dark' | 'light' = 'dark';

  @HostBinding('class')
  @Input()
  size?: 'small' | 'big' = 'small';

  @Input()
  disableTooltip = false;

  get tooltipClass(): string {
    return `default-tooltip ${this.customTooltipClass} ${this.colorType === 'light' ? 'light-mode' : ''} ${this.size === 'big' ? 'h-5 w-5' : ''}`;
  }

  protected isTooltipTextTemplateRef(): boolean {
    return !!(this.tooltipText as TemplateRef<any>)?.elementRef;
  }
}
